const putZeroInFront = (number) => {
    if (number < 10) {
        return number = "0" + number;
    } else {
        return number
    }
}

const converteFormatDateAPI = (year, month, day) => {
    return `${year}${month}${day}`
}

const getCurrentDayOfTheMonth = () => {
    return new Date().getDate()
}

const getLastDayOfTheMonth = (year, month) => {
    return new Date(year, month, 0).getDate()
}

const getFirstDayOfTheMonth = (year, month) => {
    return new Date(year, month).getDate()
}

const displayDate = (date) => {
    try {
        var getYear = date.substring(0, 4);
        var getMonth = date.substring(4, 6);
        var getDay = date.substring(6);

        return getDay + "/" + getMonth + "/" + getYear;
    } catch (err) {
        console.log(err);
        return date;
    }
}

module.exports = {
    putZeroInFront: putZeroInFront,
    converteFormatDateAPI: converteFormatDateAPI,
    getLastDayOfTheMonth: getLastDayOfTheMonth,
    getFirstDayOfTheMonth: getFirstDayOfTheMonth,
    getCurrentDayOfTheMonth: getCurrentDayOfTheMonth,
    displayDate: displayDate
}


// WEBPACK FOOTER //
// ./src/components/OverallReporting/CustomFunction.js